import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Button from "@material-ui/core/Button";
import { useSelector, useDispatch } from "react-redux";
import idx from "idx";
import { removeCookie } from "../../utils/cookies";
// layout
import { colors } from "../layout/constants";
import LoadingView from "../layout/loading";
//service
import { getTestQuestions } from "../../services/test";
import { logoutUser } from "../../services/users";

const Results = ({ resultsInfo }) => {
	// redux state
	const user = useSelector((state) => state.user);
	const userToken = useSelector((state) => state.user.token);
	const dispatch = useDispatch();
	// state
	const [loading, setLoading] = useState(true);
	const [approved, setApproved] = useState(false);
	const [score, setScore] = useState(0);
	const [evaluations_left, setEvaluations_left] = useState("");
	const [user_certificate, setUser_certificate] = useState("");

	useEffect(() => {
		getTestResults();
	}, []);

	const getTestResults = () => {
		setScore(idx(resultsInfo, (_) => _.score));
		setApproved(idx(resultsInfo, (_) => _.score) >= 8 ? true : false);
		setEvaluations_left(idx(resultsInfo, (_) => _.evaluations_left));
		setUser_certificate(idx(resultsInfo, (_) => _.user_certificate));
		setTimeout(() => {
			setLoading(false);
		}, 10000);
	};

	const logout = () => {
		removeCookie("userId");
		removeCookie("mentaliaUserToken");
		removeCookie("timer");
		removeCookie("email");
		logoutUser();

		// // Redux action
		dispatch({
			type: "SET_USER_INFO",
			payload: {},
		});
	};

	return (
		<ResultsStyled>
			{loading ? (
				<LoadingView message="Procesando respuestas, calculando tu resultado..." />
			) : Object.entries(resultsInfo).length ? (
				<>
					<h2 className="result-title">
						¡{user.name}, has concluido tu evaluación
						{approved ? " de manera satisfactoria 🎉" : null}!
					</h2>

					{approved ? (
						<section>
							<p>¡Felicidades 🥳! ¡Tu evaluación fue exitosa 🎓👏🏼!</p>
							<p>
								Tu resultado fué de <span>{score}</span>, lo cual significa que aprobaste la evaluación.
								Muy pronto estarás recibiendo tu certificado en tu correo electrónico.
								
							</p>
							<p>¡Enhorabuena!</p>
						</section>
					) : (
						<section>
							<p>
								Lamentamos informarte que tu evaluación no fue exitosa ☹️, tu
								calificación fue de <span>{score}</span> cuando el mínimo para
								aprobar es de 8.
							</p>

							<p>Nos pondremos en contacto contigo para revisar las opciones.</p>
						</section>
					)}
					<Button
						className="select-button"
						variant="contained"
						color="primary"
						size="large"
						onClick={() => logout()}
					>
						Cerrar sesión
					</Button>
				</>
			) : (
				<>
					<h2 className="result-title">
						¡{user.name}, has concluido tu evaluación
						{approved ? " de manera satisfactoria 🎉" : null}!
					</h2>
					<section>
						<p>
							Lamentablemente tuvimos algunos problemas para mostrar tus
							resultados, por favor contacta a los encargados del sistema,
							utilizando el chat de este sitio o enviando un correo.
						</p>
					</section>
				</>
			)}
		</ResultsStyled>
	);
};

const ResultsStyled = styled.section`
	max-width: 900px;
	margin: 0 auto;
	padding: 2em 0;

	p {
		font-size: 1rem;
		text-align: left;
		margin: 1em 0;
	}

	span {
		font-weight: 600;
	}

	.result-title {
		font-size: 1.5em;
		font-weight: 600;
		margin: 2em 0;
	}

	.select-button {
		margin: 2em 0;
		background: #1D3E6C;
	}

	.select-button:hover {
		background: #264672;
	}
`;

export default Results;
